import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { nowNCFileConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const NCFIleStack = createStackNavigator();

const NCFIleNavigator = () => {
  return (
    <NCFIleStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {nowNCFileConfig.map(({ Component, name }) => (
        <NCFIleStack.Screen key={name} name={name} component={Component} />
      ))}
    </NCFIleStack.Navigator>
  );
};

export { NCFIleNavigator };
